import React from "react";

export const DataListContext = React.createContext();

export const useDataList = () => {
  return React.useContext(DataListContext);
};

export const DataListProvider = (props) => {
  const [showHidden, setShowHidden] = React.useState(false);

  const toggleHidden = () => {
    setShowHidden(!showHidden);
  };

  return <DataListContext.Provider value={{ showHidden, toggleHidden }}>{props.children}</DataListContext.Provider>;
};
